// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"aa95b9a0","585":"b825fdf7"}[chunkId] + ".chunk.js";
};